module.exports = __webpack_public_path__ + "img/beyond_logo.6b73fd5f.png";